<template>
  <li :class="belongs_to_only_selection?'hidden-tree-node':''">
    <div class="form-check">
      <div class="node-info-container" >
        <span class="toggle_children" v-if="must_show_toggler" @click="toggle_children">
          <i class="fas fa-plus" v-if="!show_children"></i>
          <i class="fas fa-minus" v-else-if="show_children"></i>
        </span>
        <div @click="selected_value" @mouseover="hover = true" @mouseleave="hover = false" class="selectable_node">
          <label class="form-check-label pl-0"
            v-bind:class="{
              last_related_node: lastRelatedByAny, underline: hover, marked: must_mark,
              selected_filter: selectedNodeByAny, no_results: useNoResultsClass
            }" :for="id">{{ name }}
          </label>
          <span v-if="counts_visible" class="badge badge-pill" :class="totalBadgeClass">
            {{ total }}
          </span>
        </div>
      </div>
      <ul class="list-unstyled">
        <transition name="fade" v-for="child in children" :key="`transition_${child.id}`">
          <forms-tree-node-vue
            v-show="must_show_children"
            :key="child.id"
            v-bind="child"
            :counts_visible="counts_visible"
            ref="children"
            class="font-weight-normal"
            :selected="selected"
            :related_to_doc="childRelatedToDoc(child.name)"
            :opened_children="opened_children"
            @value_selected="value_selected"
            @status_changed="child_changed"
            :filter_name="filter_name"
            :hasSearchTokens="hasSearchTokens"
          />
        </transition>
      </ul>
    </div>
  </li>
</template>

<script>
  import mixins from 'common/mixins.js'
  import { mapState } from 'vuex'

  export default {
    props: {
      id: { type: String, default: ""},
      name: { type: String, default: ""},
      children: { type: Array, default: () => []},
      total:  { type: Number, default: 0},
      counts_visible: { type: Boolean, default: true },
      selected: { type: Array, default: () => []},
      related_to_doc: { type: Boolean, default: false },
      opened_children: { type: Array, default: () => [] },
      filter_name: { type: String, default: '' },
      hasSearchTokens: { type: Boolean, default: () => false }
    },
    data: function() {
      return {
        show_children: false,
        hover: false,
        isRelatedToDoc: this.related_to_doc,
        checked: false,
      }
    },
    name: 'forms-tree-node-vue',
    mixins: [mixins.regex_utils, mixins.filters, mixins.tree_node],
    computed: {
      ...mapState('search', ['filters']),
      totalBadgeClass() {
        return this.total ? 'badge-primary' : 'badge-secondary';
      },
      useNoResultsClass() {
        return this.total == 0 && this.counts_visible && this.hasSearchTokens
      },
      has_children() {
        return this.children.length > 0
      },
      must_show_toggler() {
        return this.has_children
      },
      must_show_children() {
        return this.show_children
      },
      belongs_to_only_selection(){
        return this.only_selection_visible && !(this.checked || this.indeterminate)
      },
      must_mark() {
        return this.id == this.selected
      },
      isLastRelatedNode() {
        return (!this.has_children && this.isRelatedToDoc ) ||
                (!this.anyChildrenRelated && this.isRelatedToDoc)
      },
      anyChildrenRelated() {
        for (let i = 0; i < this.children.length; i++) {
          const child = this.children[i];
          const isRelated = this.childRelatedToDoc(child.name)
          if (isRelated) {
            return true;
          }
        }
        return false;
      },
      isSelectedFromFilters() {
        return this.filters.some((filter) => filter.values == this.id)
      },
      lastRelatedByAny() {
        return this.isLastRelatedNode || this.isSelectedFromFilters
      },
      selectedNodeByAny() {
        return this.isRelatedToDoc || this.checked || this.isSelectedFromFilters
      },
      filterValues() {
        let filters = this.filters.find((filter) => filter.name == this.filter_name)
        if(filters && filters.values){
          return filters.values[0]
        } else {
          return ''
        }
      },
    },
    methods: {
      toggle_children() {
        this.show_children = !this.show_children;
      },
      value_selected(id, name){
        this.$emit('value_selected', id, name)
      },
      childRelatedToDoc(node_name) {
        return this.docRelated(node_name, this.opened_children)
      },
      selectedNode() {
        if (this.has_children && !this.checked) {
          this.checked = this.$refs.children.some((child) => {
            return child.$data.checked
          })
          this.$emit('status_changed')
        }
      },
      selectedFromFilters() {
        if(this.isSelectedFromFilters){
          this.selected_value()
        }
      },
      child_changed() {
        this.selectedNode()
        this.$emit('status_changed', this.id)
      },
      selected_value(){
        this.$emit('value_selected', this.id, this.name)
        this.checked = true
      }
    },
    watch:{
      checked(){
        this.$emit('status_changed')
        this.show_children = this.selectedNodeByAny
      },
      filterValues() {
      this.checked = this.isSelectedFromFilters
      }
    },
    mounted(){
      this.selectedFromFilters()
    },
  }
</script>
